/**
 * Created by andrey on 23.12.2025
 */

Object.assign(AdsLimits.TYPES, {
    PIXEL: "pixel",
    PIXEL_CREATE: "pixel_create",
    BANK: "bank",
    CINEMA: "cinema",
    OPEN_CHEST: "chest",
    THIRD_ELEMENT: "third_element",
    THIRD_ELEMENT_CREATE: "third_element_create",
    BARREL: "barrel",
    SPEEDUP: "speedup",
    WORKER: "worker"
});

AdsLimits.THRESHOLDS = {
    undecided: { level: 6 },
    nonpayer6: { level: 11 },
    nonpayer11: { level: 16 },
    nonpayer16: {}
};
